// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper--i5Iwb {
  position: relative;
}[dir] .wrapper--i5Iwb {
  margin-top: 20px;
}

[dir=ltr] .flagIcon--EyIVF {
  margin-left: 10px;
}

[dir=rtl] .flagIcon--EyIVF {
  margin-right: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/OverviewSingleLocationMultiSubject/styles.css"],"names":[],"mappings":"AAAA;EAEE,kBAAkB;AACpB,CAHA;EACE,gBAAgB;AAElB;;AAEA;EACE,iBAAiB;AACnB;;AAFA;EACE,kBAAiB;AACnB","sourcesContent":[".wrapper {\n  margin-top: 20px;\n  position: relative;\n}\n\n.flagIcon {\n  margin-left: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper--i5Iwb`,
	"flagIcon": `flagIcon--EyIVF`
};
export default ___CSS_LOADER_EXPORT___;
